// extracted by mini-css-extract-plugin
export default {"inputWithLabel":"styles_inputWithLabel__yjkc7","prefix":"styles_prefix__szGve","dropdownWrapper":"styles_dropdownWrapper__+6y+w","select":"styles_select__NlC-W"};